<template>
  <div>
    <GoogleMapLoader
      :markers="markers"
      :mapConfig="mapConfig"
      :apiKey="apiKey"
      :innerHeight="innerHeight">
      <template slot-scope="{ google, map }">
        <GoogleMapMarker
          v-for="marker in markers"
          :key="marker.id"
          :marker="marker"
          :google="google"
          :map="map" />
        <GoogleMapLine
          v-for="line in lines"
          :key="line.id"
          :path.sync="line.path"
          :google="google"
          :map="map" />
      </template>
    </GoogleMapLoader>
  </div>
</template>

<script>
import GoogleMapLoader from '@/components/google-map-loader/GoogleMapLoader.vue'
import GoogleMapMarker from '@/components/google-map-loader/GoogleMapMarker.vue'
import GoogleMapLine from '@/components/google-map-loader/GoogleMapLine.vue'

import { mapSettings } from '@/components/google-map-loader/settings/mapSettings'

export default {
  name: 'Map',
  components: {
    GoogleMapLoader,
    GoogleMapMarker,
    GoogleMapLine
  },
  props: {
    locations: {
      type: Array,
      required: true
    },
    innerHeight: {
      type: String,
      default: '500px'
    }
  },
  computed: {
    mapConfig () {
      return {
        ...mapSettings,
        center: { lat: 0, lng: 0 }
      }
    },
    markers () {
      const locations = this.locations
      if (locations) {
        const len = locations.length
        return locations.map((location, index) => {
          let order = index + 1
          return {
            id: `m${order}`,
            order,
            duration: location.duration,
            name: location.name,
            startday: location.startday,
            pass: order === len,
            position: {
              lat: Number(location.lat),
              lng: Number(location.lng)
            }
          }
        })
      }
      return []
    },
    lines () {
      const locations = this.locations
      let lines = []
      if (locations) {
        locations.forEach((location, index) => {
          let order = index + 1
          const nextLocation = locations[order]
          if (nextLocation) {
            const path = [
              { lat: Number(location.lat), lng: Number(location.lng) },
              { lat: Number(nextLocation.lat), lng: Number(nextLocation.lng) }
            ]
            lines.push({ id: `l${order}`, path })
          }
        })
        // Adding the last line
        // if (locations.length > 2) {
        //   const lastIndex = locations.length - 1
        //   const firstIndex = 0
        //   const path2 = [
        //     { lat: Number(locations[lastIndex].lat), lng: Number(locations[lastIndex].lng) },
        //     { lat: Number(locations[firstIndex].lat), lng: Number(locations[firstIndex].lng) }
        //   ]
        //   lines.push({ id: `ll`, path: path2 })
        // }
        return lines
      }
      return lines
    },
    apiKey () {
      return process.env.VUE_APP_MAP_API_KEY
    }
  }
}
</script>
